import { HINT, LABEL } from "@/components/tool-kit/styles";

/*
 * Rows of letters lined up column for column — plain text over key over cipher text —
 * with the first `shaded` columns marked (an autokey primer, a Nihilist keyword). A real
 * table, so a screen reader can read down a column. Vocabulary-free.
 */

export interface KeyStreamRow {
  label: string;
  letters: readonly string[];
}

export function KeyStream({
  title,
  rows,
  shaded,
  note,
}: {
  title: string;
  rows: readonly KeyStreamRow[];
  /** How many columns, from the left, carry the key's start. */
  shaded: number;
  note?: string;
}) {
  return (
    <div className="space-y-2">
      <p className={LABEL}>{title}</p>
      <div className="overflow-x-auto">
        <table
          aria-label={title}
          className="border-separate border-spacing-0.5"
        >
          <tbody>
            {rows.map((row) => (
              <tr key={row.label}>
                <th
                  className="whitespace-nowrap pr-3 text-left font-medium text-muted-foreground text-xs [overflow-wrap:normal]"
                  scope="row"
                >
                  {row.label}
                </th>
                {row.letters.map((letter, column) => (
                  <td
                    className={`h-7 w-7 border text-center font-mono text-sm ${
                      column < shaded
                        ? "border-amber-500 bg-amber-200/60 dark:bg-amber-400/25"
                        : "border-border bg-card"
                    }`}
                    // biome-ignore lint/suspicious/noArrayIndexKey: letters are positional
                    key={column}
                  >
                    {letter}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {note ? <p className={HINT}>{note}</p> : null}
    </div>
  );
}
